import { createTheme } from "@mui/material/styles";

// Define the theme
const theme = createTheme({
  palette: {
    primary: {
      main: "#1E88E5", // Modern blue
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#FF4081", // Vibrant pink
      contrastText: "#ffffff",
    },
    background: {
      default: "#f4f6f8", // Light gray
      paper: "#ffffff",
    },
    text: {
      primary: "#2C3E50", // Dark blue-gray
      secondary: "#7F8C8D", // Muted gray
    },
  },
  typography: {
    fontFamily: "'Poppins', sans-serif",
    h1: {
      fontSize: "2.5rem",
      fontWeight: 600,
    },
    body1: {
      fontSize: "1rem",
    },
    button: {
      textTransform: "none", // Keeps button text normal
      fontWeight: 600,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: "8px",
          padding: "10px 20px",
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: "12px",
          boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
        },
      },
    },
  },
});

export default theme;
